module.exports = __webpack_public_path__ + "static/media/no-result.451d0d08.svg";